<template>
  <div class="card" :style="styles">
    <div class="card-body">
      <img :src="image.src" :alt="image.alt">
      <h5 class="card-title">{{ text.title }}</h5>
      <button-component
        :grid="{ columns: 6 }"
        :text="button.text"
        :action="button.action"
        :styles="button.styles"
        :addClass="button.class"
        class="col-6"
      />
    </div>
  </div>
</template>

<script>
import ButtonComponent from './button-component.vue';
export default {
  name: "card",
  components: {
    ButtonComponent
  },
  props: {
    text: {
      type: Object,
      default: () => {}
    },
    image: {
      type: Object,
      default: () => {}
    },
    button: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0;
  background: #FFFFFF;
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.07);
  border-radius: 20px;
  .card-body {
    padding: 0;
    img {
      width: 100%;
      height: 330px;
      @media (max-width: 767px) {
        height: auto;
      }
    }
    .card-title {
      margin: 20px auto;
    }
  }
}
</style>